/**
 * Conversor de número para extenso (PT-BR).
 *
 * Port 1:1 de Labead\Helpers\Extenso::converte() (includes/helpers/class-extenso.php),
 * usado para manter o preview client-side (ex: exemplo de "Descrição do pagamento" em
 * gestao/alunos/edit.php) com o mesmo texto que seria gerado no contrato pelo back-end.
 * Só suporta BRL (única moeda usada pelo Labead) — as demais moedas do PHP nunca são
 * exercitadas em produção.
 */

const LB_EXTENSO_C = ['', 'cem', 'duzentos', 'trezentos', 'quatrocentos', 'quinhentos', 'seiscentos', 'setecentos', 'oitocentos', 'novecentos'];
const LB_EXTENSO_C_FEM = ['', 'cem', 'duzentas', 'trezentas', 'quatrocentas', 'quinhentas', 'seiscentas', 'setecentas', 'oitocentas', 'novecentas'];
const LB_EXTENSO_D = ['', 'dez', 'vinte', 'trinta', 'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa'];
const LB_EXTENSO_D10 = ['dez', 'onze', 'doze', 'treze', 'quatorze', 'quinze', 'dezesseis', 'dezessete', 'dezoito', 'dezenove'];
const LB_EXTENSO_U = ['', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove'];
const LB_EXTENSO_U_FEM = ['', 'uma', 'duas', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove'];

/**
 * @param {string|number} valor    Valor numérico (ponto-decimal, ex: "1234.56").
 * @param {boolean}       moeda    true = formata como "X reais e Y centavos".
 * @param {boolean}       feminino true = "uma"/"duas" em vez de "um"/"dois" (ex: parcelas).
 * @return {string} Ex: "mil duzentos e trinta e quatro reais e cinquenta e seis centavos".
 */
function lbExtenso(valor, moeda = false, feminino = false) {
	if (valor === '' || valor === null || typeof valor === 'undefined' || isNaN(parseFloat(valor))) {
		return '';
	}

	const numero = Math.abs(parseFloat(valor));

	const singular = moeda ? ['centavo', 'real', 'mil', 'milhão', 'bilhão', 'trilhão', 'quatrilhão'] : ['', '', 'mil', 'milhão', 'bilhão', 'trilhão', 'quatrilhão'];
	const plural = moeda ? ['centavos', 'reais', 'mil', 'milhões', 'bilhões', 'trilhões', 'quatrilhões'] : ['', '', 'mil', 'milhões', 'bilhões', 'trilhões', 'quatrilhões'];

	const d = LB_EXTENSO_D;
	const d10 = LB_EXTENSO_D10;

	const fixed = numero.toFixed(2);
	const [intPart, centPart] = fixed.split('.');

	// Agrupa em blocos de 3 dígitos (milhar), com os centavos como último bloco.
	const groups = [];
	let rest = intPart.replace(/^0+(?=\d)/, '');
	while (rest.length > 3) {
		groups.unshift(rest.slice(-3));
		rest = rest.slice(0, -3);
	}
	groups.unshift(rest);
	groups.push(centPart);
	const inteiro = groups.map(g => g.padStart(3, '0'));

	const fim = inteiro.length - (parseInt(inteiro[inteiro.length - 1], 10) > 0 ? 1 : 2);

	let z = 0;
	let rt = '';

	for (let i = 0; i < inteiro.length; i++) {
		const grupo = inteiro[i];
		const grupoNum = parseInt(grupo, 10);
		const d1 = parseInt(grupo[1], 10);
		const d2 = parseInt(grupo[2], 10);

		const t = inteiro.length - 1 - i;
		// Feminino só nas classes das unidades (t = 1) e do milhar (t = 2; t = 0 são os
		// centavos) — milhão/bilhão são masculinos. O milhar exato continua "um mil".
		const fem = feminino && t >= 1 && t <= 2 && !(t === 2 && grupoNum === 1);
		const c = fem ? LB_EXTENSO_C_FEM : LB_EXTENSO_C;
		const u = fem ? LB_EXTENSO_U_FEM : LB_EXTENSO_U;

		const rc = (grupoNum > 100 && grupoNum < 200) ? 'cento' : c[parseInt(grupo[0], 10)];
		const rd = d1 < 2 ? '' : d[d1];
		const ru = grupoNum > 0 ? (d1 === 1 ? d10[d2] : u[d2]) : '';

		let r = rc + (rc && (rd || ru) ? ' e ' : '') + rd + (rd && ru ? ' e ' : '') + ru;

		r += r ? ' ' + (grupoNum > 1 ? (plural[t] || '') : (singular[t] || '')) : '';

		if (grupo === '000') {
			z++;
		} else if (z > 0) {
			z--;
		}

		if (t === 1 && z > 0 && parseInt(inteiro[0], 10) > 0) {
			r += (z > 1 ? ' de ' : '') + plural[t];
		}

		if (r) {
			const connector = (i > 0 && i <= fim && parseInt(inteiro[0], 10) > 0 && z < 1)
				? (i < fim ? ' ' : ' e ')
				: ' ';
			rt = rt + connector + r;
		}
	}

	rt = rt.slice(1);

	return rt ? rt.trim() : 'zero';
}

// Exposto globalmente — mesmo padrão de window.lbPriceToWc/lbPriceToBr em masks.js.
window.lbExtenso = lbExtenso;
